/* global __API_ROOT_URL__ */


export default class IDataService {
  constructor(
    $http,
    utilityService
  ) {
    this.$http = $http;
    this.serializeData = utilityService.serializeData;
    this.apiRootUrl = __API_ROOT_URL__;
    console.log('app.services.IDataService created');
  }
}
